function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */
import Log from '@deephaven/log';
import PouchCommandHistoryTable from "./PouchCommandHistoryTable.js";
import PouchCommandHistoryCache from "./PouchCommandHistoryCache.js";
var log = Log.module('PouchCommandHistoryStorage');
export class PouchCommandHistoryStorage {
  constructor() {
    _defineProperty(this, "cache", new PouchCommandHistoryCache());
    _defineProperty(this, "updateTableMap", new Map());
  }
  getUpdateTable(language) {
    if (!this.updateTableMap.has(language)) {
      this.updateTableMap.set(language, new PouchCommandHistoryTable(language, this.cache));
    }
    return this.updateTableMap.get(language);
  }
  getTable(language) {
    var _this = this;
    return _asyncToGenerator(function* () {
      return new PouchCommandHistoryTable(language, _this.cache);
    })();
  }
  addItem(language, scope, command, data) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      return _this2.updateItem(language, {
        id: "".concat(new Date().getTime()),
        name: command,
        data
      });
    })();
  }
  updateItem(language, item) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      var updateTable = _this3.getUpdateTable(language);
      var dbItem = yield updateTable.refreshItem(item.id);
      var updatedItem = _objectSpread(_objectSpread({}, dbItem !== null && dbItem !== void 0 ? dbItem : {}), item);
      log.debug('Updating item', updatedItem);
      yield updateTable.put(updatedItem);
      log.debug('Update saved');
      return item;
    })();
  }
  listenItem(language, id, listener) {
    var updateTable = this.getUpdateTable(language);
    return updateTable.onItemUpdate(id, listener);
  }
}
export default PouchCommandHistoryStorage;
//# sourceMappingURL=PouchCommandHistoryStorage.js.map